module.exports = __webpack_public_path__ + "static/media/bs.05b8dd40.webp";